import React from 'react';

// @mui/material components
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';

import CrmButton from './CrmButton';

/*
Cribbed from Material Dashboard's Notifications.jsx view

Call it with
  <ConfirmModal
    show={T/F}
    title="<Text to appear in title>"
    confirmButtonLabel="<whatever>"
    rejectButtonLabel="<whatever>"
    onConfirm={<function to call when 'confirm' button is clicked>}
    onReject={<function to call when 'reject' button or 'close' idon is clicked>}
  >
    <div>
       Some content
    </div>
    <div>
       More content
    </div>
  </ConfirmModal>
*/

const rejectUnlessBackdropClick = (event, reason, onReject) => {
  if (reason !== 'backdropClick') {
    onReject(event, reason);
  }
};

export default function ConfirmModal({
  show,
  title,
  children,
  confirmButtonLabel,
  rejectButtonLabel,
  onConfirm,
  onReject,
}) {
  const noButtonLabel = rejectButtonLabel || 'Cancel';
  const yesButtonLabel = confirmButtonLabel || 'OK';

  return (
    <div>
      <Dialog open={!!show} onClose={(event, reason) => rejectUnlessBackdropClick(event, reason, onReject)}>
        <DialogTitle>{title}</DialogTitle>
        <DialogContent>{children}</DialogContent>
        <DialogActions>
          <CrmButton outlined onClick={onReject}>
            {noButtonLabel}
          </CrmButton>
          <CrmButton filled onClick={onConfirm}>
            {yesButtonLabel}
          </CrmButton>
        </DialogActions>
      </Dialog>
    </div>
  );
}
